import React from 'react';
import { Divider } from '@meitu/saas-ui';

export const DividerLine = React.memo(() => {
    return <Divider plain style={{ borderBlockWidth: 6, margin: '16px', width: 228, minWidth: 228 }} />;
});
